import { IMG, waLink, WA_MSG, BRAND } from "../../data/content";
import { MaskLines, Reveal } from "../shared";
import { WhatsAppIcon } from "../Navbar";
import EnquireForm from "../EnquireForm";

export default function CTASection() {
  return (
    <section className="relative overflow-hidden bg-emerald-deep py-24 md:py-32" data-testid="final-cta">
      <img src={IMG.ctaWide} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" loading="lazy" />
      <div className="absolute inset-0 bg-gradient-to-b from-emerald-deep/90 via-emerald-deep/80 to-emerald-deep/95" />
      <div className="relative z-10 mx-auto grid max-w-7xl items-center gap-14 px-6 md:px-12 lg:grid-cols-2">
        <div>
          <MaskLines
            lines={["Let's create", <span key="l2" className="italic text-gold-light">your big day.</span>]}
            lineClassName="font-serif text-ivory leading-[1.02] text-5xl md:text-6xl"
            className="block"
          />
          <Reveal delay={0.3}>
            <p className="mt-8 max-w-lg text-sm md:text-base leading-relaxed text-ivory/70">
              Tell us about the two of you, your dates and your dream destination — right here. Our team will reach out within 24 hours with first ideas.
            </p>
          </Reveal>
          <Reveal delay={0.4}>
            <div className="mt-8 space-y-3 text-sm text-ivory/80">
              <p data-testid="final-cta-phone">{BRAND.phone}</p>
              <p data-testid="final-cta-email">{BRAND.email}</p>
              <p data-testid="final-cta-locations" className="text-ivory/60">{BRAND.locations.join("  ·  ")}</p>
            </div>
          </Reveal>
          <Reveal delay={0.5}>
            <a
              href={waLink(WA_MSG)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-whatsapp"
              className="mt-8 inline-flex items-center gap-3 rounded-full border border-gold/60 px-8 py-4 text-[11px] md:text-xs font-medium uppercase tracking-[0.22em] text-gold-light transition-all duration-500 hover:bg-gold hover:text-ink"
            >
              <WhatsAppIcon className="h-4 w-4" /> Chat On WhatsApp
            </a>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <div className="bg-ivory p-7 md:p-10" data-testid="final-cta-form-card">
            <p className="text-[11px] uppercase tracking-[0.3em] text-gold-text">Enquire Now</p>
            <h3 className="mt-3 font-serif text-3xl md:text-4xl text-emerald">Plan my wedding</h3>
            <div className="mt-8">
              <EnquireForm />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
